// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("/src/fonts/ongul.ttf", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* div {
  border: 1px solid black;
} */

:root {
  --nav-offset: -50;
}

@font-face {
  font-family: 'Jalnan2TTF'; /* 폰트 이름 지정 */
  src: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) format('truetype');
  font-weight: normal;
  font-style: normal;
}

.NavigationBar2_navContainer__5WU-5 {
  display: flex;
  justify-content: center;
  position: fixed;
  background-color: rgba(0, 0, 0, 0.5);
  z-Index: 100; 
  align-items: center;
  width: 100%;
  opacity: 0; /* 처음에는 보이지 않음 */
  transition: opacity 1s ease-in-out; /* opacity가 1로 변경될 때 1초 동안 부드럽게 변화 */
}

.NavigationBar2_navContainer__5WU-5.NavigationBar2_fadein__87Zt2 {
  opacity: 1; /* fade-in 클래스가 추가되면 점점 선명해짐 */
}

.NavigationBar2_navList__0wAlH {
  list-style: none;
  display: flex;
  gap: 10px;
  margin: 0;
  width: 100%;
  justify-content: space-between;
  align-items: center;
  flex-wrap: wrap;
}

.NavigationBar2_navList__0wAlH li {
  text-align: center;
  
}

.NavigationBar2_navLink__H59WP {
  align-items: center; 
  text-decoration: none;
  color: white;
  display: flex;
}

.NavigationBar2_logo__nDKvZ {
  align-items: center; 
  text-decoration: none;
  color: white;
  display: flex;
  height: 100%;
  width : 300px;

  font-family: Jalnan2TTF;
  font-size: 24px;
}

.NavigationBar2_logo__nDKvZ img {
  width: 200px;
  height: auto;;
}

.NavigationBar2_logo__nDKvZ p {
  width: 130px;
  height: auto;;
}

.NavigationBar2_hamburger__2vwmp {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  height: 20px;
  cursor: pointer;
}

.NavigationBar2_hamburger__2vwmp .NavigationBar2_bar__Vsdd9 {
  width: 25px;
  height: 1px;
  background-color: white;
  border-radius: 2px;
}

.NavigationBar2_menu__qwFQy {
  display: flex;
}

.NavigationBar2_menu__qwFQy li {
  list-style: none;
}

.NavigationBar2_menu__qwFQy a {
  color: white;
  text-decoration: none;
}

@media (max-width: 1279px) {

  :root {
    --nav-offset: -50;
  }

  /* 화면이 좁을 때 */
  /* src/components/NavigationBar.css */
  .NavigationBar2_navContainer__5WU-5 {
    justify-content: center;
    height: 50px;
  }

  .NavigationBar2_logoBox__RImNO {
    padding-left: 5%;
    padding-right: 10%;
    justify-content: space-between;
    width : 100%;
  }

  .NavigationBar2_logo__nDKvZ img {
    width: 200px;
    height: auto;;
  }
  .NavigationBar2_logo__nDKvZ p {
    height: auto;;
    font-size: 20px;
  }

  .NavigationBar2_navList__0wAlH {
    flex-wrap: nowrap;
    gap: 0px;
  }

  .NavigationBar2_navLink__H59WP {
    align-items: center; 
    text-align: start;
    text-decoration: none;
    color: white;
    display: flex;
    width: 100%;
    height: 40px;
    
  }
  
  .NavigationBar2_menu__qwFQy {
    height : 0 ;
    display: flex;
    flex-direction: column;
    /* 항목 사이의 간격 */
    margin-left: auto;
    position: absolute;
    top: 50px;
    /* 네비게이션 바 바로 아래 */
    right: 0;
    background-color: rgba(0, 0, 0, 0.5);
    width: 100%;
    /* 기본 높이는 0으로 설정 */
    overflow: hidden;
    /* 내용이 넘치지 않도록 숨김 */
    transition: height 0.2s ease-out;
    /* 높이가 늘어나는 애니메이션 */
    z-index: 99;
  }

  .NavigationBar2_menu__qwFQy.NavigationBar2_active__Xl02S {
    display: flex;
    justify-content: flex-start;
    height: 290px;  /* 병원둘러보기 추가시 height: 290px; */
    /* 메뉴 항목의 총 높이에 맞게 설정 */
  }
  
  .NavigationBar2_menu__qwFQy li {
    list-style: none;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    justify-content: center;
    
    /* 항목들을 왼쪽 정렬 */
    padding-left: 20px;
    /* 왼쪽 여백 */
    padding-right: 20px;

    /* 항목들 사이에 흰색 구분선 추가 */
    border-bottom: 1px solid white;
    
    /* 항목의 너비를 80%로 설정 */
    width: 85%;
    
  }

  .NavigationBar2_menu__qwFQy li:last-child {
    border-bottom: none;
    /* 마지막 항목에는 구분선이 안 보이게 설정 */
  }

  .NavigationBar2_menu__qwFQy a {
    font-size: 15px;
    color: white;
    text-decoration: none;
    cursor: pointer;
  }

  .NavigationBar2_logoBox__RImNO {
    display: flex;
    align-items: center;
  }

  .NavigationBar2_hamburger__2vwmp {
    right: 20px;
    top: 20px;
  }

  .NavigationBar2_navbar__Mhkw0 {
    justify-content: flex-start;
  }

}


@media (min-width: 1280px) and (max-width:1499px) {

  :root {
    --nav-offset: -100;
  }

  .NavigationBar2_navList__0wAlH {
    font-size: 16px;
  }
  
  .NavigationBar2_logo__nDKvZ img {
    width: 300px;
    height: auto;;
  }
  
  .NavigationBar2_logo__nDKvZ p {
    width: 130px;
    height: auto;;
    font-size: 30px;
  }

  .NavigationBar2_logo__nDKvZ {
    width : 320px;
  }


  .NavigationBar2_navList__0wAlH {
    width: 55%;
  }

  .NavigationBar2_navLink__H59WP {
    height: 100px;  
  }
  /* 화면이 넓을 때 */
  .NavigationBar2_hamburger__2vwmp {
    display: none;
  }
}


@media (min-width: 1500px) {

  :root {
    --nav-offset: -110;
  }

  .NavigationBar2_navList__0wAlH {
    font-size: 20px;
  }
  
  .NavigationBar2_logo__nDKvZ img {
    width: 350px;
    height: auto;;
  }
  
  .NavigationBar2_logo__nDKvZ p {
    width: 130px;
    height: auto;;
    font-size: 35px;
  }

  .NavigationBar2_logo__nDKvZ {
    width : 400px;
  }


  .NavigationBar2_navList__0wAlH {
    width: 55%;
  }

  .NavigationBar2_navLink__H59WP {
    height: 100px;  
  }
  /* 화면이 넓을 때 */
  .NavigationBar2_hamburger__2vwmp {
    display: none;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/NavigationBar2.module.css"],"names":[],"mappings":"AAAA;;GAEG;;AAEH;EACE,iBAAiB;AACnB;;AAEA;EACE,yBAAyB,EAAE,aAAa;EACxC,+DAAmD;EACnD,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,eAAe;EACf,oCAAoC;EACpC,YAAY;EACZ,mBAAmB;EACnB,WAAW;EACX,UAAU,EAAE,gBAAgB;EAC5B,kCAAkC,EAAE,oCAAoC;AAC1E;;AAEA;EACE,UAAU,EAAE,8BAA8B;AAC5C;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,SAAS;EACT,SAAS;EACT,WAAW;EACX,8BAA8B;EAC9B,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,kBAAkB;;AAEpB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,YAAY;EACZ,aAAa;AACf;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,YAAY;EACZ,aAAa;EACb,YAAY;EACZ,aAAa;;EAEb,uBAAuB;EACvB,eAAe;AACjB;;AAEA;EACE,YAAY;EACZ,YAAY;AACd;;AAEA;EACE,YAAY;EACZ,YAAY;AACd;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,8BAA8B;EAC9B,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,WAAW;EACX,uBAAuB;EACvB,kBAAkB;AACpB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,qBAAqB;AACvB;;AAEA;;EAEE;IACE,iBAAiB;EACnB;;EAEA,aAAa;EACb,qCAAqC;EACrC;IACE,uBAAuB;IACvB,YAAY;EACd;;EAEA;IACE,gBAAgB;IAChB,kBAAkB;IAClB,8BAA8B;IAC9B,YAAY;EACd;;EAEA;IACE,YAAY;IACZ,YAAY;EACd;EACA;IACE,YAAY;IACZ,eAAe;EACjB;;EAEA;IACE,iBAAiB;IACjB,QAAQ;EACV;;EAEA;IACE,mBAAmB;IACnB,iBAAiB;IACjB,qBAAqB;IACrB,YAAY;IACZ,aAAa;IACb,WAAW;IACX,YAAY;;EAEd;;EAEA;IACE,WAAW;IACX,aAAa;IACb,sBAAsB;IACtB,cAAc;IACd,iBAAiB;IACjB,kBAAkB;IAClB,SAAS;IACT,kBAAkB;IAClB,QAAQ;IACR,oCAAoC;IACpC,WAAW;IACX,kBAAkB;IAClB,gBAAgB;IAChB,mBAAmB;IACnB,gCAAgC;IAChC,mBAAmB;IACnB,WAAW;EACb;;EAEA;IACE,aAAa;IACb,2BAA2B;IAC3B,aAAa,GAAG,8BAA8B;IAC9C,uBAAuB;EACzB;;EAEA;IACE,gBAAgB;IAChB,aAAa;IACb,sBAAsB;IACtB,uBAAuB;IACvB,uBAAuB;;IAEvB,eAAe;IACf,kBAAkB;IAClB,UAAU;IACV,mBAAmB;;IAEnB,sBAAsB;IACtB,8BAA8B;;IAE9B,oBAAoB;IACpB,UAAU;;EAEZ;;EAEA;IACE,mBAAmB;IACnB,2BAA2B;EAC7B;;EAEA;IACE,eAAe;IACf,YAAY;IACZ,qBAAqB;IACrB,eAAe;EACjB;;EAEA;IACE,aAAa;IACb,mBAAmB;EACrB;;EAEA;IACE,WAAW;IACX,SAAS;EACX;;EAEA;IACE,2BAA2B;EAC7B;;AAEF;;;AAGA;;EAEE;IACE,kBAAkB;EACpB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,YAAY;IACZ,YAAY;EACd;;EAEA;IACE,YAAY;IACZ,YAAY;IACZ,eAAe;EACjB;;EAEA;IACE,aAAa;EACf;;;EAGA;IACE,UAAU;EACZ;;EAEA;IACE,aAAa;EACf;EACA,aAAa;EACb;IACE,aAAa;EACf;AACF;;;AAGA;;EAEE;IACE,kBAAkB;EACpB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,YAAY;IACZ,YAAY;EACd;;EAEA;IACE,YAAY;IACZ,YAAY;IACZ,eAAe;EACjB;;EAEA;IACE,aAAa;EACf;;;EAGA;IACE,UAAU;EACZ;;EAEA;IACE,aAAa;EACf;EACA,aAAa;EACb;IACE,aAAa;EACf;AACF","sourcesContent":["/* div {\n  border: 1px solid black;\n} */\n\n:root {\n  --nav-offset: -50;\n}\n\n@font-face {\n  font-family: 'Jalnan2TTF'; /* 폰트 이름 지정 */\n  src: url('/src/fonts/ongul.ttf') format('truetype');\n  font-weight: normal;\n  font-style: normal;\n}\n\n.navContainer {\n  display: flex;\n  justify-content: center;\n  position: fixed;\n  background-color: rgba(0, 0, 0, 0.5);\n  z-Index: 100; \n  align-items: center;\n  width: 100%;\n  opacity: 0; /* 처음에는 보이지 않음 */\n  transition: opacity 1s ease-in-out; /* opacity가 1로 변경될 때 1초 동안 부드럽게 변화 */\n}\n\n.navContainer.fadein {\n  opacity: 1; /* fade-in 클래스가 추가되면 점점 선명해짐 */\n}\n\n.navList {\n  list-style: none;\n  display: flex;\n  gap: 10px;\n  margin: 0;\n  width: 100%;\n  justify-content: space-between;\n  align-items: center;\n  flex-wrap: wrap;\n}\n\n.navList li {\n  text-align: center;\n  \n}\n\n.navLink {\n  align-items: center; \n  text-decoration: none;\n  color: white;\n  display: flex;\n}\n\n.logo {\n  align-items: center; \n  text-decoration: none;\n  color: white;\n  display: flex;\n  height: 100%;\n  width : 300px;\n\n  font-family: Jalnan2TTF;\n  font-size: 24px;\n}\n\n.logo img {\n  width: 200px;\n  height: auto;;\n}\n\n.logo p {\n  width: 130px;\n  height: auto;;\n}\n\n.hamburger {\n  display: flex;\n  flex-direction: column;\n  justify-content: space-between;\n  height: 20px;\n  cursor: pointer;\n}\n\n.hamburger .bar {\n  width: 25px;\n  height: 1px;\n  background-color: white;\n  border-radius: 2px;\n}\n\n.menu {\n  display: flex;\n}\n\n.menu li {\n  list-style: none;\n}\n\n.menu a {\n  color: white;\n  text-decoration: none;\n}\n\n@media (max-width: 1279px) {\n\n  :root {\n    --nav-offset: -50;\n  }\n\n  /* 화면이 좁을 때 */\n  /* src/components/NavigationBar.css */\n  .navContainer {\n    justify-content: center;\n    height: 50px;\n  }\n\n  .logoBox {\n    padding-left: 5%;\n    padding-right: 10%;\n    justify-content: space-between;\n    width : 100%;\n  }\n\n  .logo img {\n    width: 200px;\n    height: auto;;\n  }\n  .logo p {\n    height: auto;;\n    font-size: 20px;\n  }\n\n  .navList {\n    flex-wrap: nowrap;\n    gap: 0px;\n  }\n\n  .navLink {\n    align-items: center; \n    text-align: start;\n    text-decoration: none;\n    color: white;\n    display: flex;\n    width: 100%;\n    height: 40px;\n    \n  }\n  \n  .menu {\n    height : 0 ;\n    display: flex;\n    flex-direction: column;\n    /* 항목 사이의 간격 */\n    margin-left: auto;\n    position: absolute;\n    top: 50px;\n    /* 네비게이션 바 바로 아래 */\n    right: 0;\n    background-color: rgba(0, 0, 0, 0.5);\n    width: 100%;\n    /* 기본 높이는 0으로 설정 */\n    overflow: hidden;\n    /* 내용이 넘치지 않도록 숨김 */\n    transition: height 0.2s ease-out;\n    /* 높이가 늘어나는 애니메이션 */\n    z-index: 99;\n  }\n\n  .menu.active {\n    display: flex;\n    justify-content: flex-start;\n    height: 290px;  /* 병원둘러보기 추가시 height: 290px; */\n    /* 메뉴 항목의 총 높이에 맞게 설정 */\n  }\n  \n  .menu li {\n    list-style: none;\n    display: flex;\n    flex-direction: column;\n    align-items: flex-start;\n    justify-content: center;\n    \n    /* 항목들을 왼쪽 정렬 */\n    padding-left: 20px;\n    /* 왼쪽 여백 */\n    padding-right: 20px;\n\n    /* 항목들 사이에 흰색 구분선 추가 */\n    border-bottom: 1px solid white;\n    \n    /* 항목의 너비를 80%로 설정 */\n    width: 85%;\n    \n  }\n\n  .menu li:last-child {\n    border-bottom: none;\n    /* 마지막 항목에는 구분선이 안 보이게 설정 */\n  }\n\n  .menu a {\n    font-size: 15px;\n    color: white;\n    text-decoration: none;\n    cursor: pointer;\n  }\n\n  .logoBox {\n    display: flex;\n    align-items: center;\n  }\n\n  .hamburger {\n    right: 20px;\n    top: 20px;\n  }\n\n  .navbar {\n    justify-content: flex-start;\n  }\n\n}\n\n\n@media (min-width: 1280px) and (max-width:1499px) {\n\n  :root {\n    --nav-offset: -100;\n  }\n\n  .navList {\n    font-size: 16px;\n  }\n  \n  .logo img {\n    width: 300px;\n    height: auto;;\n  }\n  \n  .logo p {\n    width: 130px;\n    height: auto;;\n    font-size: 30px;\n  }\n\n  .logo {\n    width : 320px;\n  }\n\n\n  .navList {\n    width: 55%;\n  }\n\n  .navLink {\n    height: 100px;  \n  }\n  /* 화면이 넓을 때 */\n  .hamburger {\n    display: none;\n  }\n}\n\n\n@media (min-width: 1500px) {\n\n  :root {\n    --nav-offset: -110;\n  }\n\n  .navList {\n    font-size: 20px;\n  }\n  \n  .logo img {\n    width: 350px;\n    height: auto;;\n  }\n  \n  .logo p {\n    width: 130px;\n    height: auto;;\n    font-size: 35px;\n  }\n\n  .logo {\n    width : 400px;\n  }\n\n\n  .navList {\n    width: 55%;\n  }\n\n  .navLink {\n    height: 100px;  \n  }\n  /* 화면이 넓을 때 */\n  .hamburger {\n    display: none;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"navContainer": `NavigationBar2_navContainer__5WU-5`,
	"fadein": `NavigationBar2_fadein__87Zt2`,
	"navList": `NavigationBar2_navList__0wAlH`,
	"navLink": `NavigationBar2_navLink__H59WP`,
	"logo": `NavigationBar2_logo__nDKvZ`,
	"hamburger": `NavigationBar2_hamburger__2vwmp`,
	"bar": `NavigationBar2_bar__Vsdd9`,
	"menu": `NavigationBar2_menu__qwFQy`,
	"logoBox": `NavigationBar2_logoBox__RImNO`,
	"active": `NavigationBar2_active__Xl02S`,
	"navbar": `NavigationBar2_navbar__Mhkw0`
};
export default ___CSS_LOADER_EXPORT___;
